import { render } from "./ErrorModal.vue?vue&type=template&id=f1cbb5a8"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__